
import TeamStatistics from 'components/sports/tte/views/TeamStatistics'
import TeamStatisticsTeam from 'components/sports/tte/views/TeamStatisticsTeam'

function TteTeamStats({ data, isTeamAndMain = false, results }) {

    const stats = [
        { code: 'RALLY_AVG' },                                          // Average rally (seconds)
        { code: 'RALLY_MAX' }                                           // Longest rally (seconds)
    ]
    return (<>
        {isTeamAndMain
            ? <TeamStatisticsTeam data={data?.results} stats={stats} results={results} />
            : <TeamStatistics data={data?.results} stats={stats} />
        }

    </>);
}

export default TteTeamStats;